import { createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row m-2" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h6", { class: "mb-2 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, "Two-Factor Verification")
], -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "field-title" }, " Enable this feature to add a second layer of security to user accounts. The user will be required to enter a challenge code or provide a security key as another form of verification. ", -1 /* HOISTED */)
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = { class: "col-1" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  class: "px-2",
  for: "enableTwoFATrue"
}, "Enable", -1 /* HOISTED */)
const _hoisted_8 = { class: "col-1" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  class: "px-2",
  for: "enableTwoFAFalse"
}, "Disable", -1 /* HOISTED */)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "mb-1 d-flex align-items-center field-title" }, [
  /*#__PURE__*/_createTextVNode(" Select to allow at least one of 2-Factor verification methods below for your organization."),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_11 = { class: "pt-1 ps-1" }
const _hoisted_12 = ["id", "checked", "onChange"]
const _hoisted_13 = ["for"]
const _hoisted_14 = {
  tabindex: "0",
  href: "javascript:void(0);",
  role: "button",
  class: "ps-2"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle text-primary font-size-xs" }, null, -1 /* HOISTED */)
const _hoisted_16 = [
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormSection = _resolveComponent("FormSection")!
  const _directive_custom_popover = _resolveDirective("custom-popover")!

  return (_openBlock(), _createBlock(_component_FormSection, { title: "Security Authentication" }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input mt-1 me-0",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.securitySetup.IsEnabled) = $event)),
                value: true,
                type: "radio",
                id: "enableTwoFATrue"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelRadio, _ctx.securitySetup.IsEnabled]
              ]),
              _hoisted_7
            ]),
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input mt-1 me-0",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.securitySetup.IsEnabled) = $event)),
                value: false,
                type: "radio",
                id: "enableTwoFAFalse"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelRadio, _ctx.securitySetup.IsEnabled]
              ]),
              _hoisted_9
            ])
          ])
        ]),
        (_ctx.securitySetup.IsEnabled)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(` ${_ctx.v$.securitySetup.AllowedTypes.$error ? 'border border-danger rounded p-2' : ''} col-12 mt-3`)
            }, [
              _hoisted_10,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.twoFATypes, (type) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `${type.value}-${type.text}`
                }, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "form-check-input",
                      id: `type-${type.value}`,
                      checked: _ctx.securitySetup.AllowedTypes?.includes(type.value),
                      onChange: ($event: any) => (_ctx.handletype(type.value))
                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_12),
                    _createElementVNode("label", {
                      class: "form-check-label",
                      for: `type-${type.value}`
                    }, [
                      _createTextVNode(_toDisplayString(type.text) + " ", 1 /* TEXT */),
                      _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_14, _hoisted_16)), [
                        [_directive_custom_popover, { content: type.popover }]
                      ])
                    ], 8 /* PROPS */, _hoisted_13)
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ], 2 /* CLASS */))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _: 1 /* STABLE */
  }))
}